<ng-container [matColumnDef]="columnName">
  <th mat-header-cell *matHeaderCellDef>
    <div class="main-checkbox-container">
      <mat-checkbox
        [checked]="areAllItemsOnThisPageSelected || areAllItemsChecked"
        (change)="checkAllItemsOnThisPage()"
      ></mat-checkbox>

      <app-card
        *ngIf="checkedItems.length || areAllItemsChecked"
      >
        <div>
          {{ checkedItemsAmount }} {{ itemNamePlural }} selected
          <b
            *ngIf="!areAllItemsChecked"
            class="link"
            (click)="checkAllItems()"
          >
            Select all {{ allListItemsCount }}
          </b>
        </div>
      </app-card>
    </div>
  </th>

  <td mat-cell *matCellDef="let item; let i = index">
    <mat-checkbox
      [checked]="isItemChecked(item.id)"
      (click)="checkItem($event, item.id, i)"
    ></mat-checkbox>
  </td>
</ng-container>
